import { createContext, useContext, useState, useMemo, useCallback } from 'react';

const ToastContext = createContext(null);

export function ToastProvider({ children }) {
  const [, setToasts] = useState([]);
  const addToast = useCallback((message, type = 'default') => {
    const id = Date.now();
    setToasts((t) => [...t, { id, message, type }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), 3000);
  }, []);
  const toast = useMemo(() => {
    const fn   = (msg) => addToast(msg, 'default');
    fn.success = (msg) => addToast(msg, 'success');
    fn.error   = (msg) => addToast(msg, 'error');
    fn.info    = (msg) => addToast(msg, 'info');
    fn.warning = (msg) => addToast(msg, 'warning');
    return fn;
  }, [addToast]);
  return <ToastContext.Provider value={{ toast }}>{children}</ToastContext.Provider>;
}

export function useToast() {
  const ctx = useContext(ToastContext);
  if (!ctx) throw new Error('useToast must be inside <ToastProvider>');
  return ctx;
}

export { StatusBadge   } from './components/StatusBadge';
export { Pagination    } from './components/Pagination';
export { Drawer        } from './components/Drawer';
export { SkeletonTable } from './components/SkeletonTable';
export { PageHeader    } from './components/PageHeader';
export { ConfirmDialog } from './components/ConfirmDialog';
export { SearchInput   } from './components/SearchInput';
export { EmptyState    } from './components/EmptyState';
export { TableHead     } from './components/TableHead';
export { PermissionGuard } from './components/PermissionGuard';
export { Loader         } from './components/Loader';